/* eslint-disable no-bitwise */

/**
 * Deterministic [0, 1) float generator (Mulberry32).
 * Same seed always produces the same sequence.
 */
export type SeededRandom = () => number;

/** Builds a Mulberry32 PRNG from an unsigned 32-bit seed. */
export function createSeededRandom(seed: number): SeededRandom {
  let state = seed >>> 0;
  return () => {
    state = (state + 0x6D2B79F5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/**
 * Stable 32-bit hash of a string for seeding deterministic systems.
 * Not cryptographic.
 */
export function hashStringToSeed(value: string): number {
  let hash = 2166136261;
  for (let i = 0; i < value.length; i++) {
    hash ^= value.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}

/** Inclusive integer in [min, max] from a seeded random. */
export function randomIntInclusive(rand: SeededRandom, min: number, max: number): number {
  if (max < min) {
    return min;
  }
  return min + Math.floor(rand() * (max - min + 1));
}
